import React, { useContext } from "react";
import { RouteComponentProps } from "react-router";
import {
  useSearchResultsHelper,
  SearchResultsState,
} from "./useSearchResultsHelper";
import { AppStore } from "../../app/store";
import { CollapsibleBox, PlanCard } from "../../components";

const CoveragePlanCard: React.FC<RouteComponentProps & {
  useCurrentCoverage: boolean;
  pageState: SearchResultsState;
}> = ({ useCurrentCoverage, pageState, ...props }) => {
  const { state, dispatch } = useContext(AppStore.AppContext);
  const {
    handleAddToCompareClick,
    handleRemovePlanFromCompare,
  } = useSearchResultsHelper(state, dispatch, pageState);

  const coverage = useCurrentCoverage
    ? state.currentCoverage
    : state.nextYearCoverage;

  const labelId = useCurrentCoverage
    ? "plan_card.your_current_plan"
    : "plan_card.your_next_plan";

  if (!coverage) return null;

  return (
    <CollapsibleBox labelId={labelId} open titleClassname="current-plan-toggle">
      <PlanCard
        key={coverage.id}
        plan={coverage}
        handleAddToCompare={handleAddToCompareClick}
        handleRemoveFromCompare={handleRemovePlanFromCompare}
        isCurrentPlan={useCurrentCoverage}
        {...props}
      />
    </CollapsibleBox>
  );
};

export default CoveragePlanCard;
